import {
  Button,
  Container,
  ContentLayout,
  Header,
} from '@cloudscape-design/components';
import {
  doc,
  getFirestore,
  onSnapshot,
} from 'firebase/firestore';
import { useUserData } from 'providers/userDataProvider';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { ManageOrder } from '../../components/Orders';

export default function UpdateOrderPage() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user: { canEditOrder } } = useUserData();

  // fetch order based on orderId
  const [order, setOrder] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!orderId) return undefined;
    const unsubscribe = onSnapshot(
      doc(getFirestore(), 'orders', orderId),
      (document) => {
        if (document.exists()) {
          setOrder({ id: document.id, ...document.data() });
          setStatus('success');
        } else {
          setStatus('error');
        }
      },
      () => {
        setStatus('error');
      },
    );

    return () => unsubscribe();
  }, [orderId]);

  if (!canEditOrder) {
    return (
      <ContentLayout
        header={(
          <Header
            actions={<Button variant="normal" onClick={() => { navigate(`/orders?${searchParams.toString()}`); }}>See all orders</Button>}
          >
            Update an Order
          </Header>
        )}
      >
        <Container>{status === 'loading' ? 'Loading' : "You don't have permission to edit orders. Please contact your administrator."}</Container>
      </ContentLayout>
    );
  }

  if (!orderId || status === 'loading' || !order) {
    return (
      <ContentLayout
        header={(
          <Header
            actions={<Button variant="normal" onClick={() => { navigate(`/orders?${searchParams.toString()}`); }}>See all orders</Button>}
          >
            Update an Order
          </Header>
        )}
      >
        <Container>{status === 'loading' ? 'Loading' : 'Invalid order ID or something went wrong'}</Container>
      </ContentLayout>
    );
  }

  return (
    <ContentLayout
      header={(
        <Header
          actions={<Button variant="normal" onClick={() => { navigate(`/orders?${searchParams.toString()}`); }}>See all orders</Button>}
        >
          {order.isInternal ? 'Update Internal Order' : 'Update Customer Order'}
        </Header>
        )}
    >
      <ManageOrder initData={order} isEditing />
    </ContentLayout>
  );
}
